import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SohoComponentsModule } from 'ids-enterprise-ng';

import { LMCubeDimensionsDialogComponent } from './lm-cube-dimensions-dialog.component';
import { LMCubePeriodOverrideDialogComponent } from './lm-cube-periodoverride-dialog.component';
import { LMCubeUtilService } from './lm-cube-util.service';
import { LMCubeDimensionRowComponent } from '@modal/cubes/lm-cube-dimension-row.component';
import { LMCubePeriodDimensionComponent } from '@modal/cubes/lm-cube-period-dimension.component';
import { LMCubeDimensionsMappingComponent } from '@modal/cubes/lm-cube-dimensions-mapping.component';
import { LMCommonModule } from '@app/lm-common.module';
import { LMCubeStructuresComponent } from '@modal/cubes/lm-cube-structures.component';

@NgModule({
    declarations: [
        LMCubeDimensionsDialogComponent,
        LMCubePeriodOverrideDialogComponent,
        LMCubeStructuresComponent,
        LMCubeDimensionsMappingComponent,
        LMCubeDimensionRowComponent,
        LMCubePeriodDimensionComponent,
    ],
    providers: [LMCubeUtilService],
    imports: [FormsModule, CommonModule, SohoComponentsModule, LMCommonModule],
    exports: [
        LMCubeDimensionsDialogComponent,
        LMCubePeriodOverrideDialogComponent,
        LMCubeStructuresComponent,
        LMCubeDimensionsMappingComponent
    ]
})
export class CubesModule {}
